<template>
  <section class="main">
    <FormWrapper method="post" :action="route('disclaimer')">
      <transition name="fade">
        <Alert v-if="hasAlert" :alert="alert" />
      </transition>
      <div class="content p-3 p-md-5">
        <div class="row">
          <div class="col-12 mb-3">
            <slot />
          </div>
          <div class="col-12 mb-3">
            <Field
              type="checkbox"
              id="agrees_to_terms"
              name="agrees_to_terms"
              label="I have read and agree to the terms above"
              :value="false"
              :checkbox-value="1"
            />
          </div>
          <div class="col-12">
            <button type="submit" class="btn btn-primary">Enter Site</button>
          </div>
        </div>
      </div>
    </FormWrapper>
  </section>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts]
};
</script>